import type { Blog } from '@ztechapps/common.contract'
import type { BodyRowConfig } from '@ztechapps/webui.data-tools'
import { RowNumberBodyCell } from '@ztechapps/webui.data-tools'

import { DataListRow } from './DataListRow'

const ListViewRow = (props: BodyRowConfig<Blog>) => {
  return (
    <>
      <RowNumberBodyCell {...props} />
      <DataListRow {...props} />
    </>
  )
}

export { ListViewRow }
